import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class TableMixins extends Vue {
	tableContainerAttrs = {
		class: 'pa-0',
		fluid: true,
	};

	tableToolbarAttrs = {
		class: 'table-toolbar mb-3',
		flat: true,
		bottom: true,
	};

	tableTitleAttrs = {
		class: 'header mono900--text',
	};

	tableMessageTextAttrs = {
		class: 'body-text mono700--text mt-3',
	};

	tableProgressBarAttrs = {
		color: 'primary darken-1',
		indeterminate: true,
		absolute: true,
	};
}
